
import { useTranslation } from 'react-i18next';
import SyncText from './sync-text';


interface Props {
    title?: string;
    subtitle?: string;
    rightSection?: JSX.Element;
    leftSection?: JSX.Element;
    sync?: boolean | null | undefined;
    withBorder?: boolean;
}

export default function PageHeader({ subtitle, title, rightSection, leftSection, sync, withBorder = false }: Props): JSX.Element {
    return null;

    const { t } = useTranslation();

    return (
        <div
            className={`
                flex items-center gap-4 px-4 pt-2 h-fit 
                ${withBorder ? 'border-b border-gray-200' : ''}
            `}>
            {leftSection && (
                <div>
                    {leftSection}
                </div>
            )}
            {(title || subtitle) && (
                <div>
                    <div className="flex items-center gap-2 flex-2">
                        <div className="text-[2rem] font-medium text-gray-900 whitespace-nowrap">
                            {t(title)}
                        </div>
                        <SyncText sync={sync} />
                    </div>
                    <div className='text-sm text-gray-500 whitespace-nowrap'>
                        {subtitle}
                    </div>
                </div>
            )}
            <div className="flex-1">
                {rightSection}
            </div>
        </div>
    );
}